import {
  CollideEvent,
  CollideId,
  isOneHitCollider,
  isPowerCollider,
} from '../../defs/collide';
import type { FossilBlockEntity } from '../../entities/BlockEntity';
import { despawnBlockEntity } from '../../entities/BlockEntity';
import { GameScene } from '../../GameScene';
import { BreakEffect } from '../effects/BreakEffect';
import { InvalidEffect } from '../effects/InvalidEffect';
import { CollideHandler, ICollision } from './ICollision';

export class FossilCollision implements ICollision {
  private readonly scene: GameScene;
  private readonly entity: FossilBlockEntity;
  private readonly resolvers: { [key in CollideId]?: CollideHandler } = {
    tap: this.resolveTap,
    block: this.resolveBlock,
    attack: this.resolveAttack,
  };

  constructor(scene: GameScene, entity: FossilBlockEntity) {
    this.scene = scene;
    this.entity = entity;
  }

  public async resolve(event: CollideEvent): Promise<boolean> {
    return this.resolvers[event.id]?.call(this, event) ?? false;
  }

  private async resolveTap() {
    await new InvalidEffect(this.entity).execute();
    return false;
  }

  private async resolveBlock(event: CollideEvent) {
    this.attack();
    return true;
  }

  private async resolveAttack(event: CollideEvent) {
    if (isOneHitCollider(event.collider?.type)) {
      this.entity.c.blockFossil.count = 0;
    }
    this.attack();
    return true;
  }

  private async attack() {
    const entity = this.entity;
    const position = entity.c.position.mapPosition;
    const component = entity.c.blockFossil;

    // If count is 0, despawn block, else decrement count
    if (component.count <= 0) {
      despawnBlockEntity(this.scene, this.entity);
    } else {
      component.count -= 1;
      this.scene?.events.publish({ id: 'poke' });
    }

    // Play the break effect
    return new BreakEffect(this.scene, {
      position,
      size: entity.c.block.props,
      color: 0xb1bcca,
    }).execute();
  }
}
